import BaseCdeIcon, { CdeIconProps } from './BaseCdeIcon'
import { ReactComponent as Accept } from '../../../assets/permission-icons/accept.svg'

const CdeIconAccept: React.FC<CdeIconProps> = ({ status, onClick }) => {
  return <BaseCdeIcon onClick={onClick} status={status} icon={<Accept />} />
}

export default CdeIconAccept
